import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Link, useLocation } from 'react-router-dom';
import Sidebar from '@/components/feature/Sidebar';
import Topbar from '@/components/feature/Topbar';
import SellerShiftGate from '@/components/feature/SellerShiftGate';
import { useAuth } from '@/hooks/useAuth';
import { hasStreetSalesScope } from '@/lib/business/streetSalesScope';

export default function Layout() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia('(max-width: 1100px)').matches,
  );

  const routeSeller = Boolean(user?.isB2B && user.role === 'employee');
  if (routeSeller) {
    const multifoodsSeller = hasStreetSalesScope(user);
    const items = [
      { path: '/orders/capture', label: 'Vender', icon: 'ri-add-circle-line' },
      { path: '/orders/history', label: 'Ventas y caja', icon: 'ri-file-list-3-line' },
      ...(!multifoodsSeller ? [{ path: '/route-customers', label: 'Clientes', icon: 'ri-contacts-book-2-line' }] : [{ path: '/route-customers', label: 'Clientes empresariales', icon: 'ri-building-2-line' }]),
      ...(multifoodsSeller ? [{ path: '/business-sales?section=quotes', label: 'Cotizaciones', icon: 'ri-file-paper-2-line' }] : []),
      ...(multifoodsSeller && user.activeModules.includes('inventory') ? [{ path: '/products', label: 'Catálogo', icon: 'ri-store-2-line' }, { path: '/inventory', label: 'Entradas', icon: 'ri-inbox-archive-line' }, { path: '/settings', label: 'Impresora', icon: 'ri-printer-line' }] : []),
    ];
    return <div className="min-h-screen bg-background-100 fooddash-b2b">
      <header className="fixed inset-x-0 top-0 z-40 flex h-14 items-center justify-between border-b border-background-200 bg-background-50 px-3 shadow-sm"><Link to="/orders/capture" className="flex min-w-0 items-center gap-2"><img src="/brand/fooddash-mark-orange.png" alt="FoodDash" className="h-9 w-9 rounded-lg"/><div className="min-w-0"><p className="truncate text-sm font-semibold">{user?.businessName}</p><p className="text-[10px] text-foreground-500">{multifoodsSeller ? 'Vendedor de mostrador' : 'Vendedor de ruta'}</p></div></Link><button onClick={() => void logout()} className="grid h-9 w-9 place-items-center rounded-lg bg-background-100 text-foreground-600" aria-label="Cerrar sesión"><i className="ri-logout-box-r-line"/></button></header>
      <SellerShiftGate />
      <main className="min-h-screen px-3 pb-24 pt-[68px] sm:px-4"><Outlet /></main>
      <nav className="fixed inset-x-0 bottom-0 z-40 grid h-[68px] border-t border-background-200 bg-background-50 px-2 pb-[env(safe-area-inset-bottom)] shadow-[0_-4px_16px_rgba(15,23,42,0.06)]" style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }}>{items.map((item) => { const [pathname, search = ''] = item.path.split('?'); const active = location.pathname === pathname && (!search || location.search === `?${search}`); return <Link key={item.path} to={item.path} className={`flex min-w-0 flex-col items-center justify-center gap-1 text-[10px] font-medium sm:text-[11px] ${active ? 'text-primary-700' : 'text-foreground-500'}`}><i className={`${item.icon} text-xl`}/><span className="max-w-full truncate">{item.label}</span></Link>; })}</nav>
    </div>;
  }
  return (
    <div className={`min-h-screen bg-background-50 ${user?.isB2B ? 'fooddash-b2b' : ''}`}>
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
      />
      <Topbar sidebarCollapsed={sidebarCollapsed} />
      <SellerShiftGate />
      <main
        className="transition-all duration-300 pt-16 min-h-screen"
        style={{ marginLeft: sidebarCollapsed ? '72px' : '260px' }}
      >
        <div className="p-4 min-[800px]:p-4 xl:p-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
